// Services

import { FEATURES, MODULES } from '@src/quince-site-common/src/constants/template-info'
import { ANALYTIC_COOKIES } from '@src/quince-site-common/src/utils/constants'
import getCookie from '@src/quince-site-common/src/utils/getCookie'
import { storefrontZipcodeServicesHttpClient } from '@src/quince-site-common/src/utils/HttpClient'
// Helpers
import { captureFatalException } from '@src/quince-site-common/src/utils/sentryUtil'
import { setInLocalStorageWithExpiry } from '@src/quince-site-common/src/utils/setInLocalStorageWithExpiry'

// Constants

let userAgentPromise: Promise<string | null> | null = null

export const fetchUserAgent = async () => {
  try {
    const res = await storefrontZipcodeServicesHttpClient.get<{ body: { userAgent: string } }>('/get-user-agent')
    const userAgentVal = res.data.body.userAgent || null
    if (userAgentVal) {
      setInLocalStorageWithExpiry(ANALYTIC_COOKIES.ECOMM_UA, userAgentVal)
    }
    return userAgentVal
  } catch (error) {
    captureFatalException('Failed while fetching user agent using getUserAgent() runtime, API - /get-user-agent', {
      module: MODULES.BROWSER_INFO,
      feature: FEATURES.USER_AGENT,
      extraInfo: error,
    })
  }
  return null
}

export async function getUserAgent(): Promise<string | null> {
  const userAgent = getCookie(ANALYTIC_COOKIES.ECOMM_UA) ?? null
  if (userAgent) {
    return userAgent
  }

  if (!userAgentPromise) {
    userAgentPromise = fetchUserAgent().finally(() => {
      resetUserAgentPromise()
    })
  }

  return await userAgentPromise
}

export async function getUa() {
  return await getUserAgent()
}

const resetUserAgentPromise = () => {
  userAgentPromise = null
}
